var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 121,
    viewBox: "0 0 114 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4679_3817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1473 93.0692H77.7019L75.2875 85.2598C75.6455 85.5715 96 103 96 103V26.7656C95.7589 22.0269 91.6745 18 86.6116 18L27.165 18.0106C22.1056 18.0106 18 22.0446 18 26.7833V84.3C18 89.2973 22.0985 93.0692 27.1473 93.0692ZM64.5447 38.1273L64.4277 38.1698L64.4703 38.1273H64.5447ZM37.4894 42.6217C43.9882 37.8971 50.0119 38.1238 50.0119 38.1238L50.4976 38.6019C42.5452 40.4967 38.9395 44.0454 38.9395 44.0454C39.3082 43.9675 55.3655 34.7131 74.823 44.2792C74.823 44.2792 71.2102 40.9606 63.747 38.8356L64.4065 38.1875C65.4382 38.191 70.8982 38.3823 76.7411 42.65C76.7411 42.65 83.2789 53.8063 83.2789 67.5125C83.0626 67.2504 79.2229 73.4129 69.3417 73.6254C69.3417 73.6254 67.6683 71.7342 66.477 70.0838C72.2561 68.4263 74.4188 65.1113 74.4188 65.1113C63.1691 72.1875 53.3092 71.0825 41.5135 66.3013C41.4035 66.3013 41.3539 66.2517 41.2972 66.195V66.1738C41.2405 66.1206 41.1908 66.0675 41.0809 66.0675H40.8682C40.1449 65.5929 39.6627 65.3592 39.6627 65.3592C39.6627 65.3592 41.8219 68.6742 47.3705 70.3317C45.9134 71.9927 44.4704 73.8804 44.4704 73.8804C34.5927 73.6467 30.9905 67.4842 30.9905 67.4842C30.9905 53.7567 37.4894 42.6217 37.4894 42.6217Z",
    fill: "#00FF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1829 63.2306C67.7037 63.2306 69.7565 61.1056 69.7565 58.4848C69.7565 55.8817 67.7144 53.7567 65.1829 53.7567V53.7673C62.6727 53.7673 60.6164 55.8852 60.6093 58.506C60.6093 61.1056 62.6621 63.2306 65.1829 63.2306Z",
    fill: "#00FF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.81 63.2306C51.3308 63.2306 53.3836 61.1056 53.3836 58.4848C53.3836 55.8817 51.345 53.7567 48.8242 53.7567L48.81 53.7673C46.2892 53.7673 44.2364 55.8852 44.2364 58.506C44.2364 61.1056 46.2892 63.2306 48.81 63.2306Z",
    fill: "#00FF79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4679_3817",
    x: 0.131662,
    y: 0.131662,
    width: 113.737,
    height: 120.737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93417
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.472973 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4679_3817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4679_3817",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/DiscordLogo.22953b8f09a38a6a93858c22b5880ed7.svg";
export { ForwardRef as ReactComponent };